import AXIOS from '@/axios-instance';

export default {

  addProcessReleaseRequest(releaseRequest) {
    return AXIOS.post("/bpmn/release/", releaseRequest);
  },
  getProcessReviewerFromReleaseHistory(uuid){
    return AXIOS.get("/bpmn/release/"+uuid+"/reviewer");
  },
  retrieveReviewProcesses(){
    return AXIOS.get("/bpmn/release/reviewer");
  },
  changeRequestState(request){
    return AXIOS.post("/bpmn/release/review", request);
  }
}